import z from 'zod';

export const boardSchema = z.object({
  id: z.string(),
  title: z.string(),
  post_count: z.number().int().nonnegative(),
  updated_at: z.string(),
});

export const boardsResponseSchema = z.array(boardSchema);

export const createBoardRequestSchema = z.object({
  title: z.string().trim().min(1),
});

export const updateBoardTitleRequestSchema = z.object({
  title: z.string().trim().min(1),
});

export const addPostsToBoardRequestSchema = z.object({
  post_ids: z.array(z.string()).min(1),
});

export const removePostsFromBoardRequestSchema = z.object({
  post_ids: z.array(z.string()).min(1),
});

export const removePostsFromBoardResponseSchema = z.object({
  removed_count: z.number().int().nonnegative(),
});

export const postsInBoardRequestSchema = z.object({
  page: z.number().int().positive(),
  limit: z.number().int().positive().max(100),
});
